/* DN: Ritual-Quiz v4 — Routing auf der freigegebenen KNV-Ritual-Matrix (alle 10 Rituale).
   Flow: Alter+Geschlecht → Bedürfnis (Q1) → NatureClub (Mail+AGB, Pflicht) →
   Feinabstimmung (Q2, echte A/B-Verzweigung → Primär- vs. Alternativ-Ritual) → Ergebnis.
   Ergebnis-Rituale (Produkte/Preise/URLs/Texte) kommen aus dem JSON-Island der Section.
   Ergebnis-Copy claim-sicher (Zustands-/Ritual-Sprache). Klaviyo via öffentliche Client-API. */
(function () {
  var script = document.currentScript || document.querySelector('[data-dn-quiz-config]');
  if (!script) return;
  var KEY = script.dataset.klaviyoKey;
  var LIST = script.dataset.klaviyoList;
  var REVISION = '2025-04-15';

  var AGE = ['18-29', '30-44', '45-59', '60+'];
  var GENDER = ['Frau', 'Mann', 'Keine Angabe'];

  /* Bedürfnis (Q1) → Feinabstimmung (Q2, A/B) → Ritual-Key (no1..no10). Aus KNV-Finder-Routing. */
  /* Bedürfnis (Q1) → Feinabstimmung (Q2, A/B) → Ritual-Key (no1..no10). Routing aus der
     freigegebenen KNV-Matrix; Beschriftungen bewusst claim-frei (keine Anti-Aging-,
     Detox-, Vitalitäts- oder Wirkaussagen — HCVO). */
  var NEEDS = [
    { k: 'immun', label: 'Immunsystem & Grundversorgung', q2: 'Woran ist dir mehr gelegen?',
      a: { t: 'Tägliches Fundament', key: 'no9' }, b: { t: 'Fundament plus Beauty-Essentials', key: 'no4' } },
    { k: 'energie', label: 'Morgen- & Tagesroutine', q2: 'Wann passt es dir am besten?',
      a: { t: 'Kurzes Ritual am Morgen', key: 'no7' }, b: { t: 'Über den Tag verteilt', key: 'no5' } },
    { k: 'haut', label: 'Haut', q2: 'Wie weit soll dein Beauty-Fokus gehen?',
      a: { t: 'Vor allem meine Haut', key: 'no3' }, b: { t: 'Haut plus Haare & Nägel', key: 'no1' } },
    { k: 'haarnagel', label: 'Haare & Nägel', q2: 'Wie weit soll dein Beauty-Fokus gehen?',
      a: { t: 'Gezielt Haare & Nägel', key: 'no10' }, b: { t: 'Rundum: Haut, Haare & Nägel', key: 'no1' } },
    { k: 'beauty', label: 'Ganzheitliche Beauty-Routine', q2: 'Wie umfassend darf es sein?',
      a: { t: 'Schlanker Einstieg', key: 'no5' }, b: { t: 'Das komplette Set', key: 'no1' } },
    { k: 'bewegung', label: 'Struktur & Bewegung', q2: 'Worauf liegt der Schwerpunkt?',
      a: { t: 'Struktur pur', key: 'no6' }, b: { t: 'Struktur plus Haut', key: 'no3' } },
    { k: 'pflanzlich', label: 'Pflanzliche Essentials', q2: 'Wie umfangreich soll es sein?',
      a: { t: 'Zwei Essentials, schlank', key: 'no8' }, b: { t: 'Drei Essentials mit MSM', key: 'no2' } },
    { k: 'abend', label: 'Abend & Ausklang', q2: 'Was passt besser zu dir?',
      a: { t: 'Mit MSM und Mariendistel', key: 'no2' }, b: { t: 'Schlankes pflanzliches Duo', key: 'no8' } }
  ];

  function init(root) {
    var dataEl = root.querySelector('[data-dn-quiz-data]');
    var stage = root.querySelector('[data-dn-quiz-stage]');
    if (!dataEl || !stage) return;
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var L = cfg.labels || {};
    var R = {};
    (cfg.rituals || []).forEach(function (r) { if (r.key) R[r.key] = r; });

    var introHTML = stage.innerHTML;
    var view, hist, age, gender, needIdx, q2pick, resultKey, depth, joinedClub, first, mail, sentKey;

    function reset() {
      view = 'intro'; hist = []; age = ''; gender = ''; needIdx = null; q2pick = null;
      resultKey = null; depth = 'system'; joinedClub = false; first = ''; mail = ''; sentKey = '';
    }
    reset();

    function go(v) { hist.push(view); view = v; render(); }
    function back() { if (hist.length) { view = hist.pop(); render(); } }
    function emailOk(e) { return /.+@.+\..+/.test(e); }
    /* DN: Nutzereingaben (Vorname/E-Mail) landen in innerHTML -> escapen, sonst zerlegt
       ein Name mit Anfuehrungszeichen oder spitzen Klammern das Markup. */
    function esc(v) {
      return String(v == null ? '' : v)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function need() { return NEEDS[needIdx]; }
    function currentKey() { if (resultKey) return resultKey; var n = need(); return n ? n.a.key : 'no9'; }

    function progFor(v) {
      var map = { demo: 1, need: 2, gate: 3, refine: 4, result: 4 };
      var n = map[v] || 0, h = '<div class="dn-quiz__prog">';
      for (var i = 0; i < 4; i++) h += '<span' + (i < n ? ' class="on"' : '') + '></span>';
      return h + '</div>';
    }

    /* Schritt 1: Alter + Geschlecht (Doppelauswahl) */
    function demo() {
      var h = progFor('demo') + '<p class="dn-quiz__eyebrow">Schritt 1 von 4</p>' +
        '<h3 class="dn-quiz__q">Für wen stellen wir dein Ritual zusammen?</h3>' +
        '<p class="dn-quiz__grouplabel">Wie alt bist du?</p><div class="dn-quiz__chips" data-g-age>';
      AGE.forEach(function (a) { h += '<button type="button" class="dn-quiz__chip' + (age === a ? ' is-sel' : '') + '" data-age="' + a + '">' + a + '</button>'; });
      h += '</div><p class="dn-quiz__grouplabel">Was beschreibt dich?</p><div class="dn-quiz__chips" data-g-gender>';
      GENDER.forEach(function (g) { h += '<button type="button" class="dn-quiz__chip' + (gender === g ? ' is-sel' : '') + '" data-gender="' + g + '">' + g + '</button>'; });
      h += '</div><p class="dn-quiz__hint dn-quiz__hint--center">Hilft uns bei Ansprache & Empfehlung.</p>' +
        '<div class="dn-quiz__spacer"></div>' +
        '<button type="button" class="button w-full dn-quiz__next"' + ((age && gender) ? '' : ' disabled') + '>Weiter</button>';
      if (hist.length) h += '<button type="button" class="dn-quiz__back">‹ Zurück</button>';
      stage.innerHTML = h;
      Array.prototype.forEach.call(stage.querySelectorAll('[data-age]'), function (b) { b.addEventListener('click', function () { age = b.getAttribute('data-age'); render(); }); });
      Array.prototype.forEach.call(stage.querySelectorAll('[data-gender]'), function (b) { b.addEventListener('click', function () { gender = b.getAttribute('data-gender'); render(); }); });
      var nx = stage.querySelector('.dn-quiz__next'); if (nx) nx.addEventListener('click', function () { if (age && gender) go('need'); });
      var bk = stage.querySelector('.dn-quiz__back'); if (bk) bk.addEventListener('click', back);
    }

    /* Schritt 2: Bedürfnis (Q1) */
    function needScreen() {
      var h = progFor('need') + '<p class="dn-quiz__eyebrow">Schritt 2 von 4 · dein Bedürfnis</p>' +
        '<h3 class="dn-quiz__q">Worum soll es bei deinem Ritual vor allem gehen?</h3><div class="dn-quiz__opts">';
      NEEDS.forEach(function (n, i) {
        h += '<button type="button" class="dn-quiz__opt' + (needIdx === i ? ' is-sel' : '') + '" data-ni="' + i + '"><span class="dn-quiz__dot"></span><span>' + n.label + '</span></button>';
      });
      h += '</div><div class="dn-quiz__spacer"></div>' +
        '<button type="button" class="button w-full dn-quiz__next"' + (needIdx === null ? ' disabled' : '') + '>Weiter</button>' +
        '<button type="button" class="dn-quiz__back">‹ Zurück</button>';
      stage.innerHTML = h;
      Array.prototype.forEach.call(stage.querySelectorAll('.dn-quiz__opt'), function (b) {
        b.addEventListener('click', function () { needIdx = +b.getAttribute('data-ni'); resultKey = null; q2pick = null; render(); });
      });
      stage.querySelector('.dn-quiz__next').addEventListener('click', function () { if (needIdx !== null) go('gate'); });
      stage.querySelector('.dn-quiz__back').addEventListener('click', back);
    }

    /* Schritt 3: NatureClub-Gate (Vorname + E-Mail + AGB, Pflicht) */
    function gate() {
      var club = L.clubName || 'NatureClub';
      /* DN: Das Gate wird auch NACH dem Ergebnis erreicht (Rabatt-Option in der Spar-Box).
         Dann ist es kein "Schritt 3 von 4" mehr, und alle Wege muessen zum Ergebnis zurueck. */
      var fromResult = !!resultKey;
      stage.innerHTML = progFor(fromResult ? 'result' : 'gate') +
        '<p class="dn-quiz__eyebrow">' + (fromResult ? (L.gateEyebrow || 'Fast geschafft') : 'Schritt 3 von 4 · ' + club) + '</p>' +
        '<h3 class="dn-quiz__q">' + (L.gateHeading || 'Wohin dürfen wir deine persönliche Ritual-Auswahl senden?') + '</h3>' +
        '<p class="dn-quiz__sub">' + (L.gateSub || 'Optional: Wir senden dir deine Ritual-Auswahl per E-Mail.') + '</p>' +
        '<input class="dn-quiz__field" type="text" autocomplete="given-name" placeholder="Dein Vorname" value="' + esc(first) + '" data-q-name>' +
        '<input class="dn-quiz__field" type="email" autocomplete="email" placeholder="deine@email.de" value="' + esc(mail) + '" data-q-email>' +
        '<label class="dn-quiz__consent"><input type="checkbox" data-q-consent><span>' +
        (function () {
          /* DN: Pflicht-Sternchen nur anhaengen, wenn der Einwilligungstext keins mitbringt (sonst doppelt). */
          var lbl = L.gateConsent || 'Ich stimme zu, meine Ritual-Auswahl & ' + club + '-Vorteile per E-Mail zu erhalten, und akzeptiere die AGB & Datenschutzbestimmungen. Abmeldung jederzeit möglich.';
          if (lbl.indexOf('dn-quiz__req') === -1) lbl += ' <span class="dn-quiz__req">*</span>';
          return lbl;
        })() +
        '</span></label>' +
        '<p class="dn-quiz__msg" hidden></p><div class="dn-quiz__spacer"></div>' +
        '<button type="button" class="button w-full dn-quiz__reveal">' +
        (fromResult ? (L.gateCta || 'Code sichern') : 'Weiter zur Feinabstimmung') + '</button>' +
        '<button type="button" class="dn-quiz__back dn-quiz__skipmail">' +
        (fromResult ? 'Ohne Code zum Ergebnis' : (L.gateSkip || 'Ohne E-Mail zum Ergebnis')) + '</button>' +
        '<button type="button" class="dn-quiz__back">‹ Zurück</button>';
      stage.querySelector('.dn-quiz__reveal').addEventListener('click', function () {
        first = (stage.querySelector('[data-q-name]').value || '').trim();
        mail = (stage.querySelector('[data-q-email]').value || '').trim();
        var consent = stage.querySelector('[data-q-consent]').checked;
        var msg = stage.querySelector('.dn-quiz__msg');
        if (!first) { msg.textContent = 'Bitte gib deinen Vornamen ein.'; msg.hidden = false; return; }
        if (!emailOk(mail)) { msg.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.'; msg.hidden = false; return; }
        if (!consent) { msg.textContent = 'Bitte bestätige kurz die Einwilligung, dann geht es weiter.'; msg.hidden = false; return; }
        joinedClub = true;
        if (resultKey) { sendToKlaviyo(first, mail); go('result'); return; }
        go('refine');
      });
      stage.querySelector('.dn-quiz__skipmail').addEventListener('click', function () {
        joinedClub = false; first = ''; mail = '';
        go(resultKey ? 'result' : 'refine');
      });
      stage.querySelectorAll('.dn-quiz__back:not(.dn-quiz__skipmail)').forEach(function (b) { b.addEventListener('click', back); });
    }

    /* Schritt 4: Feinabstimmung (Q2, echte Verzweigung) */
    function refine() {
      var n = need();
      var h = progFor('refine') + '<p class="dn-quiz__eyebrow">Schritt 4 von 4 · Feinabstimmung</p>' +
        '<h3 class="dn-quiz__q">' + n.q2 + '</h3><div class="dn-quiz__opts">' +
        '<button type="button" class="dn-quiz__opt' + (q2pick === 'a' ? ' is-sel' : '') + '" data-p="a"><span class="dn-quiz__dot"></span><span>' + n.a.t + '</span></button>' +
        '<button type="button" class="dn-quiz__opt' + (q2pick === 'b' ? ' is-sel' : '') + '" data-p="b"><span class="dn-quiz__dot"></span><span>' + n.b.t + '</span></button>' +
        '</div><div class="dn-quiz__spacer"></div>' +
        '<button type="button" class="button w-full dn-quiz__next"' + (q2pick ? '' : ' disabled') + '>Mein Ritual anzeigen</button>' +
        '<button type="button" class="dn-quiz__back">‹ Zurück</button>';
      stage.innerHTML = h;
      Array.prototype.forEach.call(stage.querySelectorAll('.dn-quiz__opt'), function (b) {
        b.addEventListener('click', function () { q2pick = b.getAttribute('data-p'); render(); });
      });
      stage.querySelector('.dn-quiz__next').addEventListener('click', function () {
        if (!q2pick) return;
        resultKey = q2pick === 'a' ? n.a.key : n.b.key;
        if (joinedClub) sendToKlaviyo(first, mail);
        stage.innerHTML = progFor('result') + '<p class="dn-quiz__eyebrow">Einen Moment</p>' +
          '<h3 class="dn-quiz__q">Wir stellen dein Ritual zusammen&hellip;</h3>' +
          '<div style="margin:28px auto;width:30px;height:30px;border:3px solid #E5DCCC;border-top-color:#241A12;border-radius:50%;animation:dnqspin .8s linear infinite"></div>' +
          '<style>@keyframes dnqspin{to{transform:rotate(360deg)}}</style>';
        setTimeout(function () { go('result'); }, 1400);
      });
      stage.querySelector('.dn-quiz__back').addEventListener('click', back);
    }

    function sendToKlaviyo(name, email) {
      if (!cfg.klaviyo || !cfg.klaviyo.enabled || !KEY || !LIST) return;
      /* DN: Doppelsendungen vermeiden, wenn zwischen Feinabstimmung und Ergebnis
         vor- und zurueckgesprungen wird. */
      var stamp = email + '|' + currentKey();
      if (sentKey === stamp) return;
      sentKey = stamp;
      var r = R[currentKey()] || {}, n = need() || {};
      var rUrl = (r.bundle && r.bundle.url) || (r.essentials && r.essentials[0] && r.essentials[0].url) || '';
      if (rUrl && rUrl.indexOf('http') !== 0) rUrl = 'https://dailynature.com' + rUrl;
      if (rUrl) rUrl += (rUrl.indexOf('?') >= 0 ? '&' : '?') + 'utm_source=klaviyo&utm_medium=email&utm_campaign=ritual-quiz';
      if (rUrl) rUrl = 'https://dailynature.com/discount/NATURE15?redirect=' + encodeURIComponent(rUrl.replace(/^https?:\/\/[^\/]+/, ''));
      var props = {
        'Ritual-Ergebnis': r.name || currentKey(),
        'Ritual-URL': rUrl,
        'Quiz-Beduerfnis': n.label || '',
        'Quiz-Feinabstimmung': q2pick === 'a' ? (n.a ? n.a.t : '') : (n.b ? n.b.t : ''),
        'Alter': age,
        'Geschlecht': gender
      };
      var profile = { data: { type: 'profile', attributes: { email: email, properties: props,
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } };
      if (name) profile.data.attributes.first_name = name;
      post('subscriptions', { data: { type: 'subscription', attributes: {
        custom_source: 'Ritual-Quiz', profile: profile },
        relationships: { list: { data: { type: 'list', id: LIST } } } } });
      if (cfg.klaviyo.event) {
        post('events', { data: { type: 'event', attributes: {
          metric: { data: { type: 'metric', attributes: { name: cfg.klaviyo.event } } },
          properties: props,
          profile: { data: { type: 'profile', attributes: { email: email } } } } } });
      }
    }
    function post(path, payload) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(KEY), {
        method: 'POST', headers: { 'Content-Type': 'application/json', revision: REVISION }, body: JSON.stringify(payload)
      }).catch(function () {});
    }

    function qurl(u) {
      if (!u) return u;
      var sep = u.indexOf('?') >= 0 ? '&' : '?';
      return u + sep + 'utm_source=quiz&utm_medium=onsite&utm_campaign=ritual-finder&utm_content=' + encodeURIComponent(currentKey());
    }

    /* Ergebnis: 1 Ritual (klickbar → Produkt/Checkout) + Essentials + Cross-Sell */
    function result() {
      var r = R[currentKey()];
      if (!r) { stage.innerHTML = '<p>Kein Ergebnis konfiguriert.</p>'; return; }
      var sec = R[r.crossSell];
      var setup = (r.bundle ? r.bundle.title : r.name) + ' ' + (L.system || 'als komplettes Ritual');
      var h = progFor('result') + '<p class="dn-quiz__eyebrow">' + (first ? 'Personalisiert für ' + esc(first) : 'Dein Ergebnis') + (r.rhythm ? ' · ' + r.rhythm : '') + '</p>' +
        '<span class="dn-quiz__badge">' + (L.resultBadge || 'Dein Ritual') + ' · ' + (r.subline || '') + '</span>' +
        '<h3 class="dn-quiz__result-name">' + r.name + '</h3>' +
        (r.desc ? '<p class="dn-quiz__result-desc">' + r.desc + '</p>' : '') +
        (r.why ? '<p class="dn-quiz__sub">' + r.why + '</p>' : '') +
        '<p class="dn-quiz__setup">Empfehlung · ' + setup + '</p>';
      if (r.bundle) {
        /* DN: Ritual-Karte ist selbst der Warenkorb-Zugang (KNV 24.07.): Klick legt das Set
           in den Warenkorb, die Maske bleibt offen. */
        var cardClickable = r.bundle.variantId && r.bundle.available !== false;
        h += '<button type="button" class="dn-quiz__bundle dn-quiz__bundle--btn' + (r.bundle.image ? ' dn-quiz__bundle--img' : '') + '"' +
          (cardClickable ? ' data-card-vid="' + r.bundle.variantId + '"' : ' disabled') + '>' +
          (r.bundle.image ? '<img class="dn-quiz__bundle-img" src="' + r.bundle.image + '" alt="" width="84" height="84">' : '') +
          '<span class="dn-quiz__bundle-body"><span class="dn-quiz__bundle-role" data-card-role>' +
          (cardClickable ? 'Ritual-Set \u00B7 zum Warenkorb hinzuf\u00FCgen' : 'Ritual-Set \u00B7 derzeit nicht verf\u00FCgbar') + '</span>' +
          '<span class="dn-quiz__bundle-name">' + r.bundle.title + '</span>' +
          (r.bundle.note ? '<span class="dn-quiz__bundle-note">' + r.bundle.note + '</span>' : '') +
          '<span class="dn-quiz__bundle-price">' + (r.bundle.compareAt ? '<s class="dn-quiz__bundle-price-old">' + r.bundle.compareAt + '</s> ' : '') + '<b class="dn-quiz__bundle-price-now">' + r.bundle.price + '</b></span></span>' +
          (cardClickable ? '<span class="dn-quiz__bundle-addicon" data-card-icon aria-hidden="true">+</span>' : '') +
          '</button>';
      }
      if (r.bundle && r.bundle.price) {
        /* DN: hervorgehobene Box zeigt die Ersparnis statt des Endpreises und traegt die
           Rabatt-Option direkt in sich (KNV 24.07.). */
        /* Die Ersparnis war als 15 Prozent VOM SETPREIS gerechnet. Der Set-Vorteil
           liegt aber zwischen Streichpreis und Setpreis: bei No. 5 sind das
           77,97 minus 66,27 = 11,70 Euro, ausgewiesen wurden 9,94. Das verkauft
           das Angebot unter Wert und passt nicht zum Streichpreis daneben.
           Jetzt die echte Differenz, mit Rueckfall auf die alte Rechnung, falls
           kein Streichpreis hinterlegt ist. */
        var zahl = function (s) {
          var n = parseFloat(String(s).replace(/[^0-9,\.]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.'));
          return isFinite(n) ? n : 0;
        };
        var save15 = (function () {
          try {
            var jetzt = zahl(r.bundle.price), vorher = zahl(r.bundle.compareAt);
            var diff = vorher > jetzt ? vorher - jetzt : jetzt * 0.15;
            if (!(diff > 0)) return '';
            return diff.toFixed(2).replace('.', ',') + '\u00A0\u20AC';
          } catch (e) { return ''; }
        })();
        if (save15) {
          h += '<div class="dn-quiz__save"><span class="dn-quiz__save-head">15\u00A0% Willkommensvorteil</span>' +
            '<p class="dn-quiz__save-line">Du sparst <strong>' + save15 + '</strong> auf dein Ritual-Set (einmalig, auf die erste Bestellung).</p>';
          if (joinedClub) {
            h += '<p class="dn-quiz__save-note">' + (L.codeNote || 'Dein 15\u00A0%-Code ist auf dem Weg in dein Postfach.') + '</p>';
          } else {
            h += '<button type="button" class="button w-full dn-quiz__latecta">' + (L.lateCta || '15\u00A0%-Code per E-Mail sichern') + '</button>';
          }
          h += '</div>';
        }
      }
      if (r.essentials && r.essentials.length) {
        h += '<p class="dn-quiz__ess-head">' + (L.essentialsHead || 'Essentials einzeln hinzufügen') + '</p>';
        /* DN 27.07. (KNV): Der Staffelvorteil auf ergaenzende Essentials war nirgends
           benannt. Die Zeile sagt, dass der Abzug erst im Warenkorb erscheint und an
           das Ritual gebunden ist — sonst wirkt der Preis in der Liste wie ein Fehler. */
        if (L.essentialsNote) {
          h += '<p class="dn-quiz__ess-note">' + L.essentialsNote + '</p>';
        }
        r.essentials.forEach(function (e) {
          h += '<div class="dn-quiz__ess"><a class="dn-quiz__ess-link" href="' + qurl(e.url) + '"><span>' + e.title + '</span><span class="dn-quiz__ess-price">' + e.price + '</span></a>' +
            (e.variantId && e.available !== false ? '<button type="button" class="dn-quiz__essadd" data-vid="' + e.variantId + '">+ Warenkorb</button>' : '') + '</div>';
        });
      }
      h += '<p class="dn-quiz__trust">' + (L.trust || '') + '</p><div class="dn-quiz__spacer"></div>';
      var cta = qurl(r.bundle ? r.bundle.url : (r.essentials && r.essentials[0] ? r.essentials[0].url : '#'));
      if (r.bundle && r.bundle.variantId && r.bundle.available !== false) {
        h += '<button type="button" class="button w-full dn-quiz__atc" data-vid="' + r.bundle.variantId + '" data-url="' + cta + '">' + (L.atcCta || 'Ritual in den Warenkorb legen') + '</button>';
        h += '<a class="dn-quiz__viewlink" href="' + cta + '">' + (L.resultCta || 'Ritual-Set ansehen') + '</a>';
      } else {
        h += '<a class="button w-full" href="' + cta + '">' + (L.resultCta || 'Ritual ansehen & kaufen') + '</a>';
      }
      if (sec) {
        var secUrl = sec.bundle && sec.bundle.url ? qurl(sec.bundle.url) : null;
        h += '<p class="dn-quiz__alt">' + (L.crossSell || 'Passt auch zu dir') + ': ' + (secUrl ? '<a class="dn-quiz__hintlink" href="' + secUrl + '">' + sec.name + '</a>' : sec.name) + '</p>';
      }
      h += '<button type="button" class="dn-quiz__back dn-quiz__restart">Quiz neu starten</button>';
      stage.innerHTML = h;
      var rs = stage.querySelector('.dn-quiz__restart');
      if (rs) rs.addEventListener('click', function () { reset(); render(); });
      var lc = stage.querySelector('.dn-quiz__latecta');
      if (lc) lc.addEventListener('click', function () { go('gate'); });
      /* DN: Karte und Hauptbutton loesen DENSELBEN Warenkorb-Vorgang aus (KNV 24.07.:
         "Ritual sollte in WK hinzufuegbar sein, bestenfalls ohne Maske direkt zu schliessen").
         Beide halten die Maske offen und spiegeln denselben Zustand; danach fuehrt der
         Hauptbutton zum Warenkorb, statt dasselbe Set ein zweites Mal zu legen. */
      var cardBtn = stage.querySelector('[data-card-vid]');
      var atc = stage.querySelector('.dn-quiz__atc');
      var bundleAdded = false;
      var cardRole = cardBtn ? cardBtn.querySelector('[data-card-role]') : null;
      var cardIcon = cardBtn ? cardBtn.querySelector('[data-card-icon]') : null;
      var atcLabel = atc ? atc.textContent : '';

      function reflectAdded() {
        bundleAdded = true;
        if (cardBtn) {
          cardBtn.classList.add('is-added');
          if (cardRole) cardRole.textContent = '\u2713 Im Warenkorb';
          if (cardIcon) cardIcon.textContent = '\u2713';
        }
        if (atc) {
          atc.disabled = false;
          atc.classList.add('is-added');
          atc.textContent = L.cartCta || 'Zum Warenkorb';
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
      /* DN 19.08.: Nach dem Hinzufuegen den Warenkorb-Drawer oeffnen statt den
         Nutzer auf einer Bestaetigung sitzen zu lassen. Das ist der Punkt mit der
         hoechsten Kaufabsicht im ganzen Fluss: vier Fragen beantwortet, Auswahl
         getroffen. Der Drawer zeigt den Inhalt und den Weg zur Kasse, ohne die
         Maske zu verlassen. Faellt er aus, bleibt der Weg ueber /cart. */
      function oeffneWarenkorb() {
        var d = document.getElementById('cart-drawer');
        if (d && typeof d.show === 'function') {
          /* Im Popup-Modus liegt das Quiz in einem <dialog>. Der Drawer wuerde
             dahinter aufgehen, deshalb zuerst die Maske schliessen. */
          var dlg = document.querySelector('[data-dn-quiz-dialog][open]');
          if (dlg && typeof dlg.close === 'function') dlg.close();
          d.show();
          return true;
        }
        return false;
      }

      function addBundle(vid) {
        if (bundleAdded) { if (!oeffneWarenkorb()) window.location.href = '/cart'; return; }
        if (cardRole) cardRole.textContent = 'Wird hinzugef\u00FCgt \u2026';
        if (atc) { atc.disabled = true; atc.textContent = 'Wird hinzugef\u00FCgt \u2026'; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
          .then(function (res) { if (!res.ok) throw new Error('atc'); reflectAdded(); oeffneWarenkorb(); })
          .catch(function () {
            if (cardRole) cardRole.textContent = 'Ritual-Set \u00B7 zum Warenkorb hinzuf\u00FCgen';
            if (atc) { atc.disabled = false; atc.textContent = atcLabel; }
          });
      }
      if (cardBtn) cardBtn.addEventListener('click', function () {
        /* Nach dem Hinzufuegen ist die Karte nur noch Status — sie navigiert bewusst
           NICHT, damit die Maske offen bleibt. Der Weg zum Warenkorb liegt im Button. */
        if (bundleAdded) return;
        var vid = parseInt(cardBtn.getAttribute('data-card-vid'), 10);
        if (vid) addBundle(vid);
      });
      if (atc) atc.addEventListener('click', function () {
        var vid = parseInt(atc.getAttribute('data-vid'), 10);
        if (!vid) { if (!oeffneWarenkorb()) window.location.href = atc.getAttribute('data-url') || '/cart'; return; }
        addBundle(vid);
      });
      stage.querySelectorAll('.dn-quiz__essadd').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var vid = parseInt(btn.getAttribute('data-vid'), 10);
          if (!vid || btn.disabled) return;
          btn.disabled = true; btn.textContent = '…';
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
            .then(function (res) {
              if (!res.ok) throw new Error('add');
              btn.textContent = '\u2713 Im Warenkorb';
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              oeffneWarenkorb();
            })
            .catch(function () { btn.disabled = false; btn.textContent = '+ Warenkorb'; });
        });
      });
    }

    function render() {
      if (view === 'intro') return intro();
      if (view === 'demo') return demo();
      if (view === 'need') return needScreen();
      if (view === 'gate') return gate();
      if (view === 'refine') return refine();
      return result();
    }
    function intro() { stage.innerHTML = introHTML; bindStart(); }
    function bindStart() {
      var b = stage.querySelector('.dn-quiz__start');
      if (b) b.addEventListener('click', function (e) { e.preventDefault(); go('demo'); });
    }
    bindStart();

    /* ---- Popup-Modus (natives <dialog>) ---- */
    var dialog = root.querySelector('[data-dn-quiz-dialog]');
    if (dialog && typeof dialog.showModal === 'function') {
      var lockScroll = function (on) { document.documentElement.style.overflow = on ? 'hidden' : ''; };
      var open = function () { if (!dialog.open) { dialog.showModal(); lockScroll(true); } };
      var close = function () { if (dialog.open) dialog.close(); };
      var openGlobal = function () {
        var dlg = document.querySelector('[data-dn-quiz-dialog]');
        if (dlg && typeof dlg.showModal === 'function' && !dlg.open) {
          dlg.showModal();
          document.documentElement.style.overflow = 'hidden';
        }
      };
      if (!window.__dnQuizDelegated) {
        window.__dnQuizDelegated = true;
        document.addEventListener('click', function (e) {
          var t = e.target.closest && e.target.closest('[data-dn-quiz-open], .dn-quiz__open, [href$="#ritual-quiz"]');
          if (!t) return;
          e.preventDefault();
          openGlobal();
        });
        if (location.hash === '#ritual-quiz') setTimeout(openGlobal, 300);
      }
      var closeBtn = dialog.querySelector('[data-dn-quiz-close]');
      if (closeBtn) closeBtn.addEventListener('click', close);
      dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
      dialog.addEventListener('close', function () { lockScroll(false); });
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-dn-quiz-root]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
